var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5799 17.3177V23.1103C21.5799 24.0966 20.7804 24.8961 19.7941 24.8961H3.81417C2.82787 24.8961 2.02832 24.0966 2.02832 23.1103V17.1816",
    stroke: "#758AB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 17.1817H20.1095C19.1091 17.7375 17.8797 17.6764 16.9394 17.0241L16.7637 16.9022C15.7342 16.1881 14.3697 16.1881 13.3403 16.9022L13.3403 16.9022C12.3108 17.6163 10.9463 17.6163 9.91685 16.9022L9.91684 16.9022C8.88741 16.1881 7.52286 16.1881 6.49343 16.9022L6.38208 16.9795C5.40858 17.6547 4.12904 17.6946 3.11542 17.0811L0.85791 17.0605V13.7254C0.85791 12.8569 1.56199 12.1528 2.43051 12.1528H21.1774C22.0459 12.1528 22.75 12.8569 22.75 13.7254V17.1817V17.1817Z",
    stroke: "#758AB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1465 12.1527V7.75952L10.1465 7.75952C10.9516 7.11076 12.1 7.11076 12.9051 7.75952L12.9051 7.75952V12.1527",
    stroke: "#758AB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6074 1C8.87187 6.12043 11.6073 5.60931 11.6073 5.60931C11.6073 5.60931 13.9756 6.01654 11.6074 1Z",
    stroke: "#758AB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.8a3939f6.svg";
export { ForwardRef as ReactComponent };